import React from 'react';
import { Btn } from './index.jsx';
import { isSafeLinkUrl, linkHost } from '../lib/urls';
import { palette, type } from '../design';


// The button a student is told to click to join their class.
//
// The meeting link is typed by their instructor, and React does not sanitise `href`: a
// `javascript:` value renders verbatim and runs on click, in the student's own session, on our
// origin (TTT-73). This component exists so that guard lives in exactly one place — the same link
// is rendered on four screens, and four copies of a security check is three chances to forget it.
//
// Deliberately checks the *scheme* only, not the meeting-host allowlist that
// `POST/PATCH /api/sessions` enforces. Tightening that allowlist must never delete the Join button
// from a booking a student has already paid for; new links are constrained at the write boundary
// instead.
export function JoinLink({ meetingLink, size = 'sm', showHost = true }) {
  if (!meetingLink) {
    return <Btn size={size} variant="ghost" disabled>Waiting for link</Btn>;
  }

  // Never fail silently: the student is expecting a way into their class, so say what is wrong
  // and who fixes it rather than quietly rendering nothing.
  if (!isSafeLinkUrl(meetingLink)) {
    return (
      <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2 }}>
        <Btn size={size} variant="ghost" disabled>Link unusable</Btn>
        <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: type.caption, color: palette.driftwood }}>
          Ask your instructor for a new one
        </span>
      </span>
    );
  }

  const host = showHost ? linkHost(meetingLink) : null;

  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2 }}>
      <a href={meetingLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        <Btn size={size}>Join</Btn>
      </a>
      {host && (
        <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: type.caption, color: palette.driftwood }}>
          Opens {host}
        </span>
      )}
    </span>
  );
}
